// extracted by mini-css-extract-plugin
export default {"search":"MapWidget_search__hugSa","legend":"MapWidget_legend__7msLX"};